import { render, staticRenderFns } from "./TheAlbums.vue?vue&type=template&id=37f2ceca&scoped=true&"
import script from "./TheAlbums.vue?vue&type=script&lang=js&"
export * from "./TheAlbums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f2ceca",
  null
  
)

export default component.exports